<template>
<div class="form-v1">
  <h3 class="dark-orange--text">Verificación {{X}}</h3>
  <v-layout>
    <in-calendar label="Fecha Verificación" :md="4" :date.sync="selectedItem.date" :required="true" :view_only="read_only"  class="no_pad_left"/>
    <in-select2 label="Estatus Verificación" :value.sync="selectedItem.status" :md="4" :items="implementation_status" :view_only="read_only"/>
    <v-flex md4 style="text-align: right;" class="no_pad_right">
      <br>
      <slot></slot>
    </v-flex>
  </v-layout>
  <v-layout>
    <in-text-area v-model="selectedItem.comment" label="Comentario" class="flex no_pad_left no_pad_right" :view_only="read_only">
      <fs1-tooltip text="Resultado de la verificación"/>
    </in-text-area>
  </v-layout>

  <TableFiles_d
    v-if="selectedItem.id && fname_ok"
    :disabled="read_only"
    :ex_filters="{temporary_engineering_measure_verification: selectedItem.id}"
    :merge_item="{temporary_engineering_measure_verification: selectedItem.id}"
    :name="fname+'-temv_files'"
    :config_name="fname+'-temv_files'">
  </TableFiles_d>
</div>
</template>

<script>
import {add_bs_met_if_not_exists } from '@/functions/general.js';
export default {
  name: 'layout_verification',
  props:['selectedItem','read_only','X'],
  data() {
    return {
      fname_ok:false,
      fname:'',
      implementation_status:[
        {id:'opened',name:'Abierta'},
        {id:'executed',name:'Ejecutada'},
        {id:'canceled',name:'Cancelada'},
      ]
    };
  },
  watch:{
    'selectedItem.id'(v){
      v && this.set_fname_ok();
    }
  },
  created(){
    this.selectedItem.id && this.set_fname_ok();
  },
  methods:{
    set_fname_ok(){
      if (this.fname_ok) return;
      this.fname = `lv-${this.selectedItem.id}`;
      add_bs_met_if_not_exists('temv_files/a/all',this.fname,this.$store,['gets','post_m','patch_m','deleteRq']);
      this.fname_ok=true;
    }
  }
};
</script>
